import PBService from "@irati/utils/services"
import client, {QueryOptions} from "@irati/utils/services/apollo"
import {Basket, BasketInput, MutationUpdateBasketArgs} from "@irati/types"

import clearBasket, {clearBasketKey} from "./mutations/clearBasket"
import updateBasket, {updateBasketKey} from "./mutations/updateBasket"
import canRedeemBasket from "./queries/canRedeemBasket"
import {basketErrorHandler} from "./errors/basketErrorHandler"

class BasketService extends PBService {
  clearBasket(userId: string, options: QueryOptions = {}): Promise<Basket> {
    const variables = {
      userId
    }
    return client.mutate({...options, mutation: clearBasket, variables}).then(({data}) => {
      return data[clearBasketKey]
    })
  }

  updateBasket(basket: BasketInput, options: QueryOptions = {}): Promise<Basket> {
    const variables: MutationUpdateBasketArgs = {
      userId: basket.userId,
      basket
    }
    return client.mutate({...options, mutation: updateBasket, variables}).then(async ({data}) => data[updateBasketKey])
  }

  canRedeemBasket(userId: string, options: QueryOptions = {}): Promise<boolean> {
    const variables = {
      userId
    }
    return client.query({...options, query: canRedeemBasket, variables}).then(() => true)
  }
}

const basketService = new BasketService({errorHandlers: [basketErrorHandler]})

export default basketService
